import { FilterSpecification, Map } from "maplibre-gl";
import { MutableRefObject } from "react";
import {
  FILTER_XWALK,
  SCENARIO_FILTER_XWALK,
} from "../../../../constants/schools";
import { SchoolType } from "../../../../editing_planning/data_requirements";
import { ScenarioKey } from "../../../../types/data/api";
import { MAP_LAYERS } from "../constants";
import { OPACITIES } from "./styleConstants";
import { AssignedSchool } from "../../../../types/data/dataTypes";

export const filterBySchool = (
  map: MutableRefObject<Map>,
  schools: AssignedSchool[],
  level: SchoolType,
  scenario: ScenarioKey,
) => {
  const schoolIDs = schools.map((school) => school.sch_id);
  map.current.setFilter(MAP_LAYERS.schoolPoints, [
    "all",
    FILTER_XWALK[level],
    SCENARIO_FILTER_XWALK[scenario],
    ["in", ["get", "sch_id"], ["literal", schoolIDs]],
  ] as FilterSpecification);
};

export const removeHighlightOnAssignmentBlocks = (
  map: MutableRefObject<Map>,
) => {
  map.current.setPaintProperty(
    MAP_LAYERS.planningBlocks,
    "fill-opacity",
    OPACITIES.DEFAULT,
  );
};

export const highlightAssignmentBlocks = (
  map: MutableRefObject<Map>,
  level: SchoolType,
  schools: AssignedSchool[],
  scenario: ScenarioKey,
) => {
  const schoolIDs = schools.map((school) => school.sch_id.toString());

  map.current.setPaintProperty(MAP_LAYERS.planningBlocks, "fill-opacity", [
    "case",
    [
      "all",
      ["in", ["get", `${level.toLowerCase()}_${scenario}_id_`], ...schoolIDs],
      [
        "!=",
        ["get", `${level.toLowerCase()}_${scenario}_id_`],
        ["get", `${level.toLowerCase()}_0_id_`],
      ],
    ],
    OPACITIES.NEW_ZONE,
    [
      "all",
      ["in", ["get", `${level.toLowerCase()}_${scenario}_id_`], ...schoolIDs],
      [
        "==",
        ["get", `${level.toLowerCase()}_${scenario}_id_`],
        ["get", `${level.toLowerCase()}_0_id_`],
      ],
    ],
    OPACITIES.HIGHLIGHTED,
    OPACITIES.FADED,
  ]);
};

export const showHatchOnChangedBlocksAssignments = (
  map: MutableRefObject<Map>,
  scenario: ScenarioKey,
  level: SchoolType,
  schools: AssignedSchool[],
) => {
  const schoolIDs = schools.map((school) => school.sch_id.toString());

  const filterExpression = [
    "all", // Apply all conditions
    [
      "all",
      ["==", ["get", `${level.toLowerCase()}_bund_chg`], true],
      scenario === 4 && level !== "HS",
    ],
    [
      "any", // At least one of the following conditions must be true
      ["in", ["get", `${level.toLowerCase()}_${scenario}_id_`], ...schoolIDs], // ID is in the schoolIDs array
      ["in", ["get", `${level.toLowerCase()}_0_id_`], ...schoolIDs], // ID is in the schoolIDs array for the base level
    ],
  ] as unknown as FilterSpecification;

  map.current.setFilter(MAP_LAYERS.planningBlockChanges, filterExpression);
};

export const showDualRightsOnChangedBlocksAssignments = (
  map: MutableRefObject<Map>,
  scenario: ScenarioKey,
  level: SchoolType,
  schools: AssignedSchool[],
) => {
  const schoolIDs = schools.map((school) => school.sch_id.toString());

  const filterExpression = [
    "all", // Apply all conditions
    [
      "all",
      [
        "==",
        ["get", `dual_right_status`], // Get the ID for the current level and scenario
        "had_dr", // Get the ID for the base level
      ],
      scenario === 4 && level === "MS",
    ],
    [
      "any", // At least one of the following conditions must be true
      ["in", ["get", `${level.toLowerCase()}_${scenario}_id_`], ...schoolIDs], // ID is in the schoolIDs array
      ["in", ["get", `${level.toLowerCase()}_0_id_`], ...schoolIDs], // ID is in the schoolIDs array for the base level
    ],
  ] as unknown as FilterSpecification;

  map.current.setFilter(MAP_LAYERS.dualRights, filterExpression);
};
